import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const publicProfileQuery = gql`
  query getPublicProfileOrganizationByPk($organizationId: uuid!) {
    organization_by_pk(id: $organizationId) {
      name
      description
      tax_id
      contact_name
      contact_email
      country
      city
      address
      created_date
      last_billing
    }
  }
`;

export const searchOrganizationsQuery = gql`
  query searchOrganizations($keyword: String) {
    organization(where: {_or: [{name: {_ilike: $keyword}}, {tax_id: {_ilike: $keyword}}]}) {
      id
      name
      tax_id
      contact_name
      contact_email
    }
  }
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/organization.js